import * as React from 'react';
import { FormControl } from 'react-bootstrap';

import type { QuantityUnitType } from '@acceligentllc/shared/enums/quantityUnit';
import { CompoundUnitValueLimits } from '@acceligentllc/shared/enums/quantityUnit';

import styles from '../styles.module.scss';

type Props = {
	unit: QuantityUnitType;
	onSingularCompoundUnitValueChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	compoundUnit: string;
	name: string;
	value: Nullable<number>;
};

const CompoundUnitField: React.FC<Props> = ({ unit, compoundUnit, onSingularCompoundUnitValueChange, name, value }) => {
	const limits = CompoundUnitValueLimits[unit][compoundUnit];

	return (
		<div className={styles['numeric-field__compound__single']}>
			<FormControl
				autoComplete="off"
				className={styles['numeric-field__value']}
				key={compoundUnit}
				max={limits.max}
				min={limits.min}
				onChange={onSingularCompoundUnitValueChange}
				placeholder={name}
				type="number"
				value={value ?? undefined}
			/>
			<span className={styles['numeric-field__unit']}>
				{compoundUnit}
			</span>
		</div>
	);
};

export default React.memo(CompoundUnitField);
